import { cn } from "@/lib/utils";
import { LucideIcon } from "lucide-react";
import { HTMLAttributes, ReactNode } from "react";

interface Props extends HTMLAttributes<HTMLSpanElement> {
  icon: LucideIcon;
  children: ReactNode;
}

export function LinkReference({
  icon: Icon,
  children,
  className,
  ...props
}: Props) {
  return (
    <span
      {...props}
      className={cn(
        "dark:text-brand-gray-50 inline-flex bg-brand-gray-100 dark:bg-brand-gray-800 items-center gap-1 relative top-0.5 rounded-md py-0.5 px-1.5 mx-0.5 text-inherit",
        className
      )}
    >
      <Icon size={18} strokeWidth={1.5} />
      {children}
    </span>
  );
}
